const IDB_KEY = '__idb';

export { IDB_KEY };
